/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { StackProps } from "@packages/ui";
import { Container, spacing, Stack, Text } from "@packages/ui";
import { forwardRef } from "react";

const stackStyle: Interpolation = {
  gap: spacing.none,
};

export type SectionsProps = StackProps & {
  title?: string;
};

export const Sections = forwardRef<any, SectionsProps>(
  ({ children, title, ...props }, ref) => (
    <Stack ref={ref} css={stackStyle} {...props}>
      {title && (
        <Container paddingX paddingY>
          <Text as="h1" overflow="ellipsis" size="s" type="display">
            {title}
          </Text>
        </Container>
      )}
      {children}
    </Stack>
  ),
);

Sections.displayName = "Sections";
